module.exports = __webpack_public_path__ + "img/tc3.da9e513c.png";